import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '0.5rem',
    // Add DaisyUI classes
    className: 'input input-bordered w-full',
  }),
  input: (provided) => ({
    ...provided,
    color: 'black',
    padding: '8px',
    // Add DaisyUI classes
    className: 'input ',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#f1f5f9',
    borderRadius: '0.5rem',
    padding: '2px',
  }),
};

const MultiSelectInput = ({ label, name, options, control, errors, validationRules }) => {
  return (
    <div className="form-control">
      <label className="label">
        <span className="label-text">{label}</span>
      </label>
      <Controller
        name={name}
        control={control}
        rules={validationRules}
        render={({ field }) => (
          <Select
            isMulti
            options={options}
            styles={customStyles}
            value={options.filter(option => field.value?.includes(option.value))}
            onChange={(selectedOptions) => field.onChange(selectedOptions.map(option => option.value))}
          />
        )}
      />
      {errors[name] && (
        <p className="text-error text-sm mt-1">{errors[name].message}</p>
      )}
    </div>
  );
};

export default MultiSelectInput;
